<div *ngIf="loading" class="justify-content-center align-items-center">
  <div id="overlay" class="rounded-lg">
    <div class="w-100 min-h-100 d-flex flex-column justify-content-center align-items-center">
      <div class="spinner-border spinner-border-xl text-white" role="status"></div>
      <h4 class="text-white mt-3">{{ message }}</h4>
    </div>
  </div>
</div>
